export interface ISchoolPlan {
  readonly id: string
  readonly name: string
  readonly price: string
}

export type SchoolPlans = ISchoolPlan[]
